// Settings shortcuts resolve to one administration destination. Operational actions are not routed.
export function settingsDestination(action, data={}, activePBX='default') {
 const globals={'sms-settings':'sms','mail-settings':'mail'};
 if(globals[action])return {global:globals[action]};
 if(action==='nav'&&data.page==='client-groups')return {global:'client-groups'};
 if(action==='nav'&&data.page==='workflow')return {pbx:activePBX,tab:'workflow',openOnly:true};
 const tabs={
  'opmon-settings':'reports','opmon-general':'reports','opmon-groups':'reports','opmon-hours-list':'reports',
  'opmon-slack-list':'reports','opmon-email-list':'reports','opmon-notification-tests':'reports','opmon-zoho':'reports','opmon-deliveries':'reports',
  'board-config':'board','board-queue-groups':'board','board-sync-queues':'board',
  'pbx-extensions':'extensions','pbx-edit':'connection','pbx-hotels':'hotels','pbx-live-approval':'safety',
  'ops-providers':'summaries','ops-profile':'workflow',
 };
 if(!tabs[action])return null;
 return {pbx:action.startsWith('pbx-')?(data.id||activePBX):activePBX,tab:tabs[action],openOnly:['opmon-settings','pbx-extensions'].includes(action)};
}
